import { memo } from "react";

const RadialTreeView = ({ interactor }: any) => {
  const { containerRef } = interactor;
    
  return (
    
    <div>
      <div id="tree-container" ref={containerRef}></div>
      
      <div id="toolbar" style={{ transform: "translateX(150%)translateY(30px)" }}>
        <div className="tool">
          <div id="help" title="click for help">
            <a href="help.html" target="_blank">
              HELP
            </a>
          </div>
        </div>
        <div className="tool">
          <div className="tlabel">zoom</div>
          <div className="tbuttons">
            <div
              className="button"
              data-key="187"
              title="Zoom In (+ OR scrollwheel)"
            >
              +
            </div>
            <div
              className="button"
              data-key="189"
              title="Zoom Out (− OR scrollwheel)"
            >
              −
            </div>
          </div>
        </div>
        <div className="tool">
          <div className="tlabel">rotate</div>
          <div className="tbuttons">
            <div
              className="button"
              data-key="33"
              title="Rotate CCW (Page Up OR ↑scrollwheel)"
              style={{ fontSize: "0.9em" }}
            >
              &#8634;
            </div>
            <div
              className="button"
              data-key="34"
              title="Rotate CW (Page Down OR ↑scrollwheel)"
              style={{ fontSize: "0.9em" }}
            >
              &#8635;
            </div>
          </div>
        </div>
        <div className="tool">
          <div className="tlabel">select</div>
          <div className="tbuttons">
            <div
              className="button"
              data-key="-38"
              title="Select Previous (↑)"
              style={{ fontSize: "0.9em" }}
            >
              &#8613;
            </div>
            <div
              className="button"
              data-key="-40"
              title="Select Next (↓)"
              style={{ fontSize: "0.9em" }}
            >
              &#8615;
            </div>
          </div>
        </div>
        <div className="tool">
          <div className="tlabel">view</div>
          <div className="tbuttons">
            <div className="button" data-key="36" title="Center Root (Home)">
              &#8962;
            </div>
            <div
              className="button"
              data-key="35"
              title="Center Selected (End)"
              style={{ fontSize: "0.8em" }}
            >
              &#9673;
            </div>
          </div>
        </div>
        <div className="tool">
          <div className="tlabel">toggle</div>
          <div className="tbuttons">
            <div
              className="button"
              data-key="32"
              title="Toggle Node (Space OR double-click)"
            >
              1
            </div>
            <div
              className="button"
              data-key="25"
              title="Toggle Level (Return OR ↑double-click)"
            >
              &oplus;
            </div>
            <div className="button" data-key="191" title="Toggle Root (/)">
              /
            </div>
          </div>
        </div>
        <div className="tool">
          <div
            className="tlabel"
            style={{ textAlign: "left" }}
            title="Change Root"
          >
            &nbsp;selection
          </div>
          <div id="selection" className="tlabel"></div>
        </div>
      </div>

      <div id="contextmenu">
        <div data-key="32">
          <span className="expcol">Expand</span> Node
        </div>
        <div data-key="13">Expand 1 Level</div>
        <div data-key="-13">Expand Full Tree</div>
        <div data-key="35">Center This Node</div>
        <div data-key="36">Center Root</div>
        <div data-key="191">Set Root</div>
      </div>
    </div>
  );
};

export default RadialTreeView;
